$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};

animate(".animate__scroll, .animate__offset");

$(window).scroll(function() {
  animate(".animate__scroll, .animate__offset");
});

$(".animate__trigger").click(function() {
  animate($(this).data("animate-toggle"));
});

$(function() {
  $('.links ul li:first-child a').css('opacity', 1); // Reset the opacity of the first link to 1.

  $('.links ul li a').on('mouseenter', function(e) {
      const currentIndex = $(this).index();
      const links = $('.links ul li a');

      links.not(this).each(function(index) {
          if (index !== currentIndex) {
              $(this).css('opacity', 0.5);
          }
          if(index === 0){
            $(this).css('opacity', 0.5);
          }
      });
  });

  $('.links ul li a').on('mouseleave', function(e) {
      const links = $('.links ul li a');
      links.css('opacity', 1);
  });
});


$(function() {
  const form = $('#wpforms-736'); // Replace with the actual ID of your form.
  const choices = $('ul', form).find('li');

  choices.on('click', function(e) {
      choices.removeClass('wpform-active');
      $(this).addClass('wpform-active');
      console.log('JAH');
  });
});
function animate(cssClass) {
  $(cssClass).each(function() {
      if ($(this).data("animate").length) {
          if ($(this).hasClass("animate__scroll")) {
              if ($(this).isInViewport()) {
                  $(this).attr("class", $(this).attr("class") + " " + $(this).data("animate"));
                  $(this).data("animate", "");
              }
          } else if ($(this).hasClass("animate__trigger")) {
              $(this).attr("class", $(this).attr("class") + " " + $(this).data("animate"));
              let self = this;
              setTimeout(function() {
                  var cl = $(self).attr("class").split(" ");
                  var newcl = [];
                  for (var i = 0; i < cl.length; i++) {
                      r = cl[i].search(/animate__+/);
                      if (r) newcl[newcl.length] = cl[i];
                  }
                  $(self).removeClass().addClass(newcl.join(" "));
              }, 5e3);
          } else if ($(this).hasClass("animate__offset")) {
              let elTop = $(this).offset().top;
              let offset = .5;
              if ($(this).data("animateOffset")) {
                  offset = $(this).data("animateOffset");
              }
              let scrollPos = $(window).scrollTop() + $(window).height() * $(this).data("animateOffset");
              if (scrollPos > elTop) {
                  $(this).attr("class", $(this).attr("class") + " " + $(this).data("animate"));
                  $(this).data("animate", "");
              }
          }
      }
  });
}

jQuery.fn.extend({
  autoHeight: function() {
      function autoHeight_(element) {
          return jQuery(element).css({
              height: 0,
              "overflow-y": "hidden"
          }).height(element.scrollHeight);
      }
      return this.each(function() {
          autoHeight_(this).on("input", function() {
              autoHeight_(this);
          });
      });
  }
});

$(document).foundation();

$(".logo-slider").slick({
  dots: false,
  pauseOnHover: true,
  arrows: false,
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  draggable: true,
  autoplay: true,
  cssEase:"linear",
  infinite: true,
  autoplaySpeed: 0,
  speed: 5000,
  rtl: false,
  mobileFirst: true,
  responsive: [ {
    breakpoint: 1020,
    settings: {
      slidesToShow:4,
      // centerMode:true,
    }
  }]
});

var select = $("#selectorcats");

$("#selectorcats").change(function() {
  selectedcat = this.value;
  console.log(this.value);
  $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      dataType: "html",
      data: {
          action: "filter_projects",
          category: selectedcat
      },
      success: function(res) {
          $(".blogs-con").html(res);
      }
  });
});

$(".blog-archive .desktop-select .open-button").click(function() {
  $(".blog-archive .desktop-select .custom-accordion .bottom").slideToggle();
});

$(".blog-archive .desktop-select .cat-select").click(function() {
  $(".blog-archive .desktop-select .cat-select").removeClass("active");
  selectedcat = $(this).attr("data-id");
  console.log(selectedcat);
  $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      dataType: "html",
      data: {
          action: "filter_projects",
          category: selectedcat
      },
      success: function(res) {
          $(".blogs-con").html(res);
      }
  });
  $(this).addClass("active");
});

var select = $("#selectorcats2");

$("#selectorcats2").change(function() {
  selectedcat = this.value;
  console.log(this.value);
  $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      dataType: "html",
      data: {
          action: "filter_resource",
          category: selectedcat
      },
      success: function(res) {
          $(".resource-con").html(res);
      }
  });
});

$(".resource-archive .desktop-select .open-button").click(function() {
  $(this).toggleClass("open");
  $(".resource-archive .desktop-select .custom-accordion .bottom").slideToggle();
});


$(".resource-archive .desktop-select .cat-select").click(function() {
  $(".resource-archive .desktop-select .cat-select").removeClass("active");
  selectedcat = $(this).attr("data-id");
  console.log(selectedcat);
  $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      dataType: "html",
      data: {
          action: "filter_resource",
          category: selectedcat
      },
      success: function(res) {
          $(".resource-con").html(res);
      }
  });
  $(this).addClass("active");
});

$(".flip-cards-con .flip-card").hover(function() {
  $(this).toggleClass("flipped");
});

$(".team-con .team-card").click(function() {
  $(this).toggleClass("flipped");
});

$(".post-type-banner .team-card").click(function() {
  $(this).toggleClass("flipped");
});

if ($(".hero").length == 0) {
  $(".header").addClass("space-below");
}


$(document).ready(function() {
  $('.tabbed-slider-con').each(function (i) {
        $('.tab-num-'+i).slick({
          dots: false,
          arrows: true,
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          draggable: false,
          initialSlide: 0,
          swipeToSlide: true,
          swipe: true,
          touchMove: false,
          prevArrow: $(".tabbed-content .tabbed-slider .prev.arrow-for-slider-"+i),
          nextArrow: $(".tabbed-content .tabbed-slider .next.arrow-for-slider-"+i),
          responsive: [ {
              breakpoint: 760,
              settings: {
                  slidesToShow: 2
              }
          }, {
              breakpoint: 1020,
              settings: {
                  slidesToShow: 3
              }
          } ]
        });
        
        $('.tab-num-'+i).slick("reinit");
  });
});






$(".schools-slider").slick({
  slidesToShow: 1,
  infinite: false,
  mobileFirst: true,
  draggable: false,
  responsive: [ {
      breakpoint: 760,
      settings: {
          arrows: true,
          slidesToShow: 1.5
      }
  }, {
      breakpoint: 1020,
      settings: {
          slidesToShow: 2.3
      }
  } ]
});


// $(document).ready(function() {
//   var ul = $('.anchor-links');
//   var text = [];
//   $(".blog-content h1").each(function(i, head) {
//     text.push($(head).text());
//     $(this).addClass("anchor-heading h1");
//     console.log("h1");
//   });
//   $(".blog-content h2").each(function(i, head) {
//     text.push($(head).text());
//     $(this).addClass("anchor-heading h2");
//     console.log("h2");
//   });
//   $(".blog-content h3").each(function(i, head) {
//     text.push($(head).text());
//     $(this).addClass("anchor-heading h3");
//     console.log("h3");
//   });
//   $(".blog-content h4").each(function(i, head) {
//     text.push($(head).text());
//     $(this).addClass("anchor-heading h4");
//     console.log("h4");
//   });
//   $(".blog-content h5").each(function(i, head) {
//     text.push($(head).text());
//     $(this).addClass("anchor-heading h5");
//     console.log("h5");
//   });
//   console.log(text);
//   text.forEach(function(text) {
//     console.log(text);
//     var trimmed = text.replace(/ /g, '');
//     console.log(trimmed)
//     ul.append('<a href="#'+ trimmed +'">' + text + '</a>');
//   });
//   $('.blog-content h1').each(function(){
//     var id = $(this).text().replace(/ /g, '');
//     $(this).attr('id', id);
//     $(this).addClass('anchor-heading'); 
//   });
//   $('.blog-content h2').each(function(){
//     var id = $(this).text().replace(/ /g, '');
//     $(this).attr('id', id);
//     $(this).addClass('anchor-heading'); 
//   });
//   $('.blog-content h3').each(function(){
//     var id = $(this).text().replace(/ /g, '');
//     $(this).attr('id', id);
//     $(this).addClass('anchor-heading'); 
//   });
//   $('.blog-content h4').each(function(){
//     var id = $(this).text().replace(/ /g, '');
//     $(this).attr('id', id);
//     $(this).addClass('anchor-heading');
//   });
//   $('.blog-content h5').each(function(){
//     var id = $(this).text().replace(/ /g, '');
//     $(this).attr('id', id);
//     $(this).addClass('anchor-heading');
//   });
// });




$(document).ready(function() {
  $("#nav-icon3").click(function() {
      $(this).toggleClass("open");
      $(".main-navigation").toggleClass("open");
  });
});

$(".nav-button").on("click", function() {
  $(".main-navigation-con").slideToggle();
  $(".navigation").toggleClass("active");
});

$(document).ready(function() {
  $(".button-popout").click(function() {
      $(this).parents(".popout").toggleClass("open");
  });
});

$(document).ready(function() {
  $(".tab-selector .button-1").click(function() {
      $(".tab-selector .button-2").removeClass("active");
      $(this).addClass("active");
      $(".tab-content .tab-2").removeClass("active");
      $(".tab-content .tab-1").addClass("active");
  });
});

$(document).ready(function() {
  $(".tab-selector .button-2").click(function() {
      $(".tab-selector .button-1").removeClass("active");
      $(this).addClass("active");
      $(".tab-content .tab-1").removeClass("active");
      $(".tab-content .tab-2").addClass("active");
  });
});

$(".product-slider-con").slick({
  slidesToShow: 4,
  infinite: false,
  mobileFirst: false,
  arrows: false,
  responsive: [ {
      breakpoint: 1020,
      settings: {
          slidesToShow: 3
      }
  }, {
      breakpoint: 760,
      settings: "unslick"
  } ]
});

$(".highlight-text__content p").wrap("<span class='highlight'></span>");

$(".highlight-text__content p").after("&nbsp;&nbsp;");

gsap.registerPlugin(ScrollTrigger);

$(".highlight").each(function() {
  gsap.to($(this), {
      scrollTrigger: {
          trigger: $(this),
          start: "top 55%",
          markers: false
      },
      opacity: 1,
      color: "#000000"
  });
});

$(".cards").slick({
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: "20%"
});

$(function() {
  $(".nav-main a").hover(function() {
      $(".nav-main a").css("color", "#5F615E");
  }, function() {
      $(".nav-main a").css("color", "");
  });
});

$(function() {
  var $carousel = $(".tabbed-slider").slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: false,
      mobileFirst: true,
      fade: true,
      swipeToSlide: false,
      swipe: false,
      touchMove: false,
      speed: 1e3,
      prevArrow: $(".tabbed-content .slider-arrows .prev"),
      nextArrow: $(".tabbed-content .slider-arrows .next"),
      responsive: [ {
          breakpoint: 760,
          settings: {
              slidesToShow: 1
          }
      } ]
  });
  var select = $("#selector");
  $("#selector").change(function() {
      goTo = select.prop("selectedIndex");
      $carousel.slick("goTo", goTo);
  });
  $(".button-selector").on("click", function() {
      $(".button-selector").removeClass("active");
      $num = $(this).attr("data-number");
      $carousel.slick("goTo", $num);
      $(this).addClass("active");
  });
   
  $('.tabbed-slider').on('afterChange', function() {
      $(".button-selector").removeClass("active");
      if ($(".slick-slide.slick-current.slick-active").hasClass("inner-slider")) {
        var dataId = $('.inner-slider.slick-slide.slick-current.slick-active').attr("data-slick-index");    

        var newid = +dataId + 1;
        $('.button-selector[data-number="' + dataId + '"]').addClass('active');
      }
      if ($(".slick-slide.slick-current.slick-active").hasClass("tabbed-slide")) {
        var dataId = $('.tabbed-slide.slick-slide.slick-active').attr("data-slick-index");    
        var newid = parseInt(dataId, 10) + 1;
        $('.button-selector[data-number="' + dataId + '"]').addClass('active');
      }
  });
});

$(".carousel-slider").slick({
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  mobileFirst: true,
  prevArrow: $(".carousel .main-con .content-con .content-buttons .buttons-con .prev"),
  nextArrow: $(".carousel .main-con .content-con .content-buttons .buttons-con .next"),
  responsive: [ {
      breakpoint: 760,
      settings: {
          slidesToShow: 2
      }
  }, {
      breakpoint: 1020,
      settings: {
          slidesToShow: 3
      }
  } ]
});

$(".testimonials-slider").slick({
  dots: false,
  arrows: true,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable: true,
  mobileFirst: true,
  prevArrow: $(".tile-grid .main-con .cta-testimonials .testimonials-con .buttons-con button.prev"),
  nextArrow: $(".tile-grid .main-con .cta-testimonials .testimonials-con .buttons-con button.next")
});

$(".testimonials-slider-2").slick({
  dots: false,
  arrows: true,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable: true,
  mobileFirst: true,
  fade: true,
  prevArrow: $(".tile-grid .main-con .trustpilot-con .buttons-con button.prev"),
  nextArrow: $(".tile-grid .main-con .trustpilot-con .buttons-con button.next")
// }).on("setPosition", function(event, slick) {
//   slick.$slides.css("height", slick.$slideTrack.height() + "px");
});

window.addEventListener("scroll", function() {
  var navigation = document.querySelector(".navigation");
  var logo = this.document.querySelector(".logo");
  if (window.scrollY > 0) {
      navigation.classList.add("scrolled");
      logo.classList.add("scrolled");
  } else {
      navigation.classList.remove("scrolled");
      logo.classList.remove("scrolled");
  }
});

$(".simple-image-component .main-con").slick({
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable: true,
  mobileFirst: true,
  centerMode: true,
  centerPadding: "15%",
  prevArrow: $(".simple-image-component .buttons-con button.prev"),
  nextArrow: $(".simple-image-component .buttons-con button.next"),
  responsive: [ {
      breakpoint: 760,
      settings: "unslick"
  } ]
});

//$(".anchor-links").toc({content: "section.blog-content", headings: "h1,h2,h3,h4,h5"});

$(".anchor-links").tableOfContents('section.blog-content', 
  {
  startLevel: 1,
  depth: 5,
  levelClass: "toc-depth-%",
} );


// change header content when selector is changed
document.addEventListener('DOMContentLoaded', function () {
  const selectorCats = document.getElementById('selectorcats');
  const termName = document.querySelector('.heading-con h1');
  const termDescription = document.querySelector('.heading-con p');

  selectorCats.addEventListener('change', function () {
      const selectedOption = selectorCats.options[selectorCats.selectedIndex];
      const newName = selectedOption.getAttribute('data-name');
      const newDescription = selectedOption.getAttribute('data-description');

      // Decode HTML entities
      const decodeHtmlEntities = (str) => {
          const textArea = document.createElement('textarea');
          textArea.innerHTML = str;
          return textArea.value;
      };

      // Update the term name and description
      termName.textContent = decodeHtmlEntities(newName);
      termDescription.textContent = decodeHtmlEntities(newDescription);
  });
});

//height of blog table content
document.addEventListener("DOMContentLoaded", () => {
  // Get all rows
  const rows = document.querySelectorAll(".table-con-new .row");

  rows.forEach((row) => {
      // Find all .content elements in the row
      const contents = row.querySelectorAll(".content");
      $perrow = parseInt(contents.length / 2);
      console.log($perrow);
      for(var i = 0; i < $perrow; i++) {
        $maxHeight = 0;
        $rowcontents = row.querySelectorAll('.set-' + i);
        console.log('.set-' + i)
        console.log($rowcontents);
        $rowcontents.forEach((rowcontent) => {
          $height = rowcontent.offsetHeight;
          console.log($maxHeight);
          if ($height > $maxHeight) {
              $maxHeight = $height;
          }
        });
        console.log($maxHeight);
        $rowcontents.forEach((rowcontent) => {
          rowcontent.style.height = `${$maxHeight}px`;
          console.log()
        });
      }
      // // Calculate the tallest height
      // contents.forEach((content) => {
      //     const height = content.offsetHeight;
      //     if (height > maxHeight) {
      //         maxHeight = height;
      //     }
      // });

      // // Apply the tallest height to all .content elements
      // contents.forEach((content) => {
      //     content.style.height = `${maxHeight}px`;
      // });
  });
});


document.addEventListener("DOMContentLoaded", () => {
  // all rows
  const rows = document.querySelectorAll(".table-con-new .row");
  rows.forEach((row) => {
      // Find all .content elements in the row
      const contents = row.querySelectorAll(".column-heading");
      let maxHeight = 0;
      // Calculate the tallest height
      contents.forEach((content) => {
          const height = content.offsetHeight;
          if (height > maxHeight) {
              maxHeight = height;
          }
      });
      // Apply the tallest height to all .content elements
      contents.forEach((content) => {
          content.style.height = `${maxHeight}px`;
      });
  });
});


console.log(343);